import { render, staticRenderFns } from "./RegStudentElement.vue?vue&type=template&id=ee91ef2e"
import script from "./RegStudentElement.vue?vue&type=script&lang=js"
export * from "./RegStudentElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports